export default {
  nav: {
    play: '플레이',
    about: '소개',
    features: '특징',
    tips: '팁',
    faq: '자주 묻는 질문'
  },
  hero: {
    title: '몬스터 서바이버',
    subtitle: '궁극의 무료 온라인 로그라이크 서바이벌 게임',
    playButton: '지금 플레이',
    learnButton: '더 알아보기'
  },
  about: {
    title: '몬스터 서바이버 소개',
    description1: '몬스터 서바이버는 끝없는 몬스터의 물결과 싸우는 흥미로운 로그라이크 서바이벌 게임입니다.',
    description2: '캐릭터를 선택하고, 능력을 업그레이드하며, 얼마나 오래 생존할 수 있는지 도전해보세요!',
    description3: '독특한 무기 조합과 캐릭터 성장 시스템으로 매 플레이마다 다른 경험을 제공합니다.',
    description4: '브라우저에서 바로 플레이 가능 - 다운로드 불필요!'
  },
  features: {
    title: '게임 특징',
    characters: {
      title: '독특한 캐릭터',
      description: '여러 캐릭터 중에서 선택할 수 있으며, 각각 고유한 특수 능력과 플레이 스타일을 가지고 있습니다.'
    },
    weapons: {
      title: '무기 진화',
      description: '다양한 무기와 아이템을 조합하여 강력한 진화 버전을 만들 수 있습니다.'
    },
    gameplay: {
      title: '끝없는 액션',
      description: '절차적으로 생성되는 레벨에서 점점 강해지는 몬스터의 물결에 맞서 싸웁니다.'
    }
  },
  tips: {
    title: '게임플레이 팁',
    tip1: {
      title: '이동 마스터하기',
      description: '공격하면서 적을 유인하고, 기동성을 활용한 전투 방식을 익히세요.'
    },
    tip2: {
      title: '빌드 계획하기',
      description: '캐릭터와 플레이 스타일에 맞는 업그레이드를 선택하세요.'
    },
    tip3: {
      title: '빠른 레벨업',
      description: '난이도 곡선을 따라잡기 위해 경험치 보석을 빠르게 수집하세요.'
    }
  },
  faq: {
    title: '자주 묻는 질문',
    q1: {
      question: '몬스터 서바이버는 무료로 플레이할 수 있나요?',
      answer: '네, 몬스터 서바이버는 웹 브라우저에서 완전히 무료로 플레이할 수 있습니다. 다운로드나 설치가 필요하지 않습니다!'
    },
    q2: {
      question: '몬스터 서바이버는 어떻게 플레이하나요?',
      answer: 'WASD로 이동하고, 스페이스바로 공격하며, E키로 특수 능력을 사용합니다. 경험치를 모아 레벨업하고 업그레이드를 선택하여 강해지세요!'
    },
    q3: {
      question: '몬스터 서바이버의 특별한 점은 무엇인가요?',
      answer: '몬스터 서바이버는 독특한 캐릭터 성장 시스템, 무기 진화 시스템, 절차적으로 생성되는 레벨을 특징으로 합니다. 매 플레이마다 다른 경험을 제공합니다!'
    }
  },
  newsletter: {
    title: '업데이트 받기',
    description: '업데이트, 팁, 특별 이벤트 정보를 받으려면 뉴스레터에 구독하세요!',
    placeholder: '이메일 입력',
    button: '구독'
  },
  related: {
    title: '비슷한 게임 추천',
    description: '이러한 훌륭한 로그라이크 서바이벌 게임들도 확인해보세요!'
  },
  footer: {
    quickLinks: '빠른 링크',
    social: '팔로우하기',
    copyright: '© 2024 몬스터 서바이버. All rights reserved.'
  },
  reviews: {
    title: '게임 리뷰',
    rating: '평가',
    commentPlaceholder: '게임 경험을 공유하세요...',
    submit: '리뷰 제출',
    ratingRequired: '평가를 선택해주세요'
  }
} 